var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAssignmentReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 4.75H27.345C26.4 2.14 23.925 0.25 21 0.25C18.075 0.25 15.6 2.14 14.655 4.75H5.25C2.775 4.75 0.75 6.775 0.75 9.25V40.75C0.75 43.225 2.775 45.25 5.25 45.25H36.75C39.225 45.25 41.25 43.225 41.25 40.75V9.25C41.25 6.775 39.225 4.75 36.75 4.75ZM21 4.75C22.2375 4.75 23.25 5.7625 23.25 7C23.25 8.2375 22.2375 9.25 21 9.25C19.7625 9.25 18.75 8.2375 18.75 7C18.75 5.7625 19.7625 4.75 21 4.75Z",
    fill: "#FCBE40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31.75H12V22.75H21V16L31.4625 26.44C31.9125 26.89 31.9125 27.5875 31.4625 28.0375L21 38.5V31.75Z",
    fill: "#101114"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssignmentReturn);
export default __webpack_public_path__ + "static/media/icon-assignment-return.96845942.svg";
export { ForwardRef as ReactComponent };